import styled from '@emotion/styled'
import { AdUnit } from '@pubstack/common/src/adunit'
import { Site } from '@pubstack/common/src/site'
import { AdmSiteConfig } from '@pubstack/common/src/siteConfig'
import { FunctionComponent } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { Colors } from '~/assets/style/colors'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { StackTemplateFlyout } from '~/modules/pbs/sites/site/stacks/StackTemplateFlyout'
import { WithClassName } from '~/types/utils'
import { PureSiteOverview } from './PureSiteOverview'
import { AdmSitePageContext } from '~/modules/pbs/sites/site/useSitePageContext'
import { Stack } from '@pubstack/common/src/stack'

const useSteps = (stacks: Stack[] | undefined, siteConfig: AdmSiteConfig | undefined, adUnits: AdUnit[], site: Site, onDefaultStackClick: () => void) => {
  const navigate = useNavigate()
  return {
    adUnits: {
      onClick: () => navigate('/monetization/one/adunits'),
      done: adUnits.some((adUnit) => adUnit.devices.includes('desktop')) && adUnits.some((adUnit) => adUnit.devices.includes('mobile')),
    },
    contextKeys: {
      onClick: () => navigate('/monetization/one/context/context-keys'),
    },
    gamAndAUnitPath: {
      onClick: () => navigate(`/monetization/one/sites/${site.id}/adserver/gam`),
      done: (siteConfig?.adUnitPathConfig?.length ?? 0) > 0,
    },
    biddersAndModules: {
      onClick: () => navigate('/monetization/inventory/catalog'),
    },
    defaultStack: {
      onClick: () => onDefaultStackClick(),
      done: stacks?.some((s) => s.name === 'Default' && s.status === 'live') ?? false,
    },
  }
}

type SiteOverviewProps = WithClassName

const BaseSiteOverview: FunctionComponent<SiteOverviewProps> = ({ className }) => {
  const navigate = useNavigate()

  const flyout = useGlobalFlyout()
  const { site: currentSite, stacks, adUnits, siteConfig, isLoading } = useOutletContext<AdmSitePageContext>()
  const onDefaultStackClick = () => {
    if (stacks === undefined || (siteConfig?.adUnitPathConfig?.length ?? 0) === 0 || adUnits.length === 0) return
    if (stacks.length > 0) {
      navigate('../stacks')
    } else {
      flyout.open(
        StackTemplateFlyout,
        { color: Colors.Lilac, width: `816px`, closeTrackingLabel: 'adm-sites-stacks-template-close' },
        {
          currentSite,
          closeFlyout: () => flyout.close(),
        }
      )
    }
  }
  const steps = useSteps(stacks, siteConfig, adUnits, currentSite, onDefaultStackClick)
  const props = {
    adManagementEnabled: currentSite.adManagementEnabled ?? false,
    steps,
    isLoading,
  }

  return <PureSiteOverview className={className} {...props} />
}
export const SiteOverview = styled(BaseSiteOverview)``
